(() => {
  let mode = document.documentElement.dataset.vatMode === 'excl' ? 'ex' : 'inc';
  let scheduled = false;
  function update(next) {
    if (next === 'ex' || next === 'inc') mode = next;
    const value = mode === 'ex' ? 'excl' : 'incl';
    if (document.documentElement.dataset.vatMode !== value) document.documentElement.dataset.vatMode = value;
    document.querySelectorAll('[data-vat-price]').forEach(el => {
      const cents = Number(el.dataset.priceCents);
      const multiplier = Number(el.dataset.vatMultiplier || 1.25);
      if (!Number.isFinite(cents)) return;
      const amount = mode === 'inc' ? Math.round(cents * multiplier) : cents;
      const text = new Intl.NumberFormat('sv-SE', {style:'currency', currency:el.dataset.currency || 'SEK'}).format(amount / 100) + (mode === 'inc' ? ' inkl. moms' : ' exkl. moms');
      if (el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('[data-vat]').forEach(el => {
      const active = el.dataset.vat === mode;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', String(active));
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-vat]');
    if (!button || !['inc','ex'].includes(button.dataset.vat)) return;
    try { localStorage.setItem('vatMode', button.dataset.vat); } catch(e) {}
    window.dispatchEvent(new CustomEvent('vat:changed', {detail:{mode:button.dataset.vat}}));
  });
  window.addEventListener('vat:changed', event => update(event.detail?.mode));
  window.addEventListener('storage', event => { if (event.key === 'vatMode') update(event.newValue === 'ex' ? 'ex' : 'inc'); });
  new MutationObserver(records => {
    if (scheduled || !records.some(r => r.type === 'attributes' || [...r.addedNodes].some(n => n.nodeType === 1))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  }).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['data-price-cents']});
  document.addEventListener('variant:update', event => {
    const html = event.detail?.data?.html;
    if (!html) return;
    html.querySelectorAll('script[data-ss-product-schema]').forEach(source => {
      document.querySelectorAll('script[data-ss-product-schema]').forEach(target => {
        if (target.dataset.ssProductSchema === source.dataset.ssProductSchema && target.textContent !== source.textContent) target.textContent = source.textContent;
      });
    });
  });
  window.SS_updateVatPrices = update;
  update();
})();
